import React, { useEffect } from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { Close, AddCircleOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import RoutePaths from "routes/RoutePaths";
import { Popover } from "components/Shared/Popover";
import { Typography } from "components/Shared/Typography";
import { Button, IconButton } from "components/Shared/Button";
import { getExpertProfile } from "redux/actions/expertProfile";
import { useAppDispatch } from "redux/store/hooks";
import { getUserTotalPoints } from "redux/actions/reservations";
import usePointsSelector from "redux/selectors/pointsSelector";
import { removeAvailablePoints } from "redux/reducers/pointsSlice";
import { useAuthSelectors } from "redux/selectors";
import { changeCurrentRole, Roles } from "redux/reducers/authSlice";
import useAuth from "features/auth/useAuth";
import { logout, setting, refresh, coin } from "assets/images";
import PointsView from "../../../Shared/PointsView";
import { getAuthUserProfile } from "redux/actions";

interface ProfilePopoverProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  anchorEl: any;
}

const ProfilePopover: React.FC<ProfilePopoverProps> = (props) => {
  const { setOpen, open, anchorEl } = props;
  const { t } = useTranslation();
  const { points, loading } = usePointsSelector();
  const { selectAuthUser } = useAuthSelectors();
  const { push } = useHistory();
  const { logoutUser } = useAuth();
  const dispatch = useAppDispatch();

  const onCurrenttRoleChange = (e: any) => {
    const toggledRole =
      e.target.checked === true ? Roles.expert : Roles.student;
    dispatch(changeCurrentRole(toggledRole));
    dispatch(getAuthUserProfile());
    if (toggledRole === Roles.expert) {
      dispatch(getExpertProfile());
      push(RoutePaths.expertHome);
    } else {
      push(RoutePaths.root);
    }
  };

  useEffect(() => {
    if (!open) {
      return;
    }
    dispatch(getUserTotalPoints());
    return () => {
      dispatch(removeAvailablePoints());
    };
  }, [dispatch, open]);

  return (
    <Popover open={open} handleClose={() => setOpen(false)} anchorEl={anchorEl}>
      <Typography variant="h6">{`${selectAuthUser?.firstName} さん`}</Typography>
      <div className="user-popover">
        <div className="item">
          <Typography className="title" component="div">
            <img src={refresh} alt="" />
            {t("headerBar.popover.header.switchProfile")}
          </Typography>
          <div className="row">
            <div className="change_role">
              <label className="label_text">
                {selectAuthUser?.currentRole === Roles.expert
                  ? t("headerBar.popover.label.teacher")
                  : t("headerBar.popover.label.student")}
              </label>
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    onChange={onCurrenttRoleChange}
                    checked={selectAuthUser?.currentRole === Roles.expert}
                    disabled={!selectAuthUser?.isExpert}
                  />
                }
                label={<div className="label_text"></div>}
                labelPlacement="end"
              />
            </div>
          </div>
        </div>
        {selectAuthUser?.currentRole === Roles.student && (
          <React.Fragment>
            <div className="item">
              <div className="btn-pop-area">
                <img src={coin} alt="" />
                <Button label={t("common.Points")} />
              </div>
              <div className="btn-pop-area">
                <span className="point-value">
                  {loading ? (
                    <React.Fragment>
                      <PulseLoader size={5} color="#EF233C" />
                    </React.Fragment>
                  ) : (
                    <PointsView points={points} />
                  )}{" "}
                </span>
                <IconButton
                  customStyles="add-icon"
                  label=""
                  icon={<AddCircleOutline />}
                  id="plus"
                  onClick={() => push(RoutePaths.studentPurchasePoints)}
                />
              </div>
            </div>
          </React.Fragment>
        )}
        <div className="btn-pop-area">
          <img src={setting} alt="" />
          <Button
            label={t("bottombar.settings")}
            onClick={() => push(RoutePaths.settings)}
          />
        </div>
        <div className="hr-seperator"></div>
        <div className="btn-pop-area">
          <img src={logout} alt="" />
          <Button
            id="logout-button"
            label={t("headerBar.popover.label.logoutBtn")}
            onClick={logoutUser}
          />
        </div>
        <div className="btn-pop-area close-btn-area">
          <Close />
          <Button
            id="close-button"
            customStyles="close-btn"
            label={t("headerBar.popover.label.close")}
            onClick={() => setOpen(false)}
          />
        </div>
      </div>
    </Popover>
  );
};

export default ProfilePopover;
